<template>
    <v-container class="pa-0">
        <SearchSavedCarts
            v-if="savedCarts.length > 0"
            :savedCarts="savedCartList"
            :original-saved-cart-list="savedCartsCopy"
            @startLoading="isLoading = true"
            @searchSavedCarts="searchSavedCarts"
            @sortByDate="sortSavedCartsByDate"
            @refreshData="fetchSavedCarts"
        />
        <v-alert
            v-if="savedCarts.length >= 50"
            color="warning"
            type="warning"
            dense
            outlined
            class="mb-0"
        >
            <div>
                <span
                    ><TranslatableStringComponent :tstring="{string: 'maxCartReachedAlert'}" /></span
                >
            </div>
        </v-alert>
        <div v-if="isLoading" class="pt-8">
            <div v-for="i in 10" :key="i" class="mb-6">
                <v-skeleton-loader
                    type="list-item-three-line"
                    class="mx-auto"
                    elevation="2"
                ></v-skeleton-loader>
            </div>
        </div>
        <div v-if="savedCarts.length > 0" class="pt-8">
            <div v-for="item in savedCartList" :key="item.id" class="mb-6">
                <SavedCartsSingle
                    :cart="item"
                    @refreshSavedCart="fetchSavedCarts"
                />
            </div>
        </div>
        <div v-else>
            <v-alert outlined dense type="info" color="primary">
                <TranslatableStringComponent :tstring="{string: 'noCartsSaved'}" />
            </v-alert>
        </div>
    </v-container>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import SavedCartsSingle from '~/components/SavedCartsSingle.vue'
import SearchSavedCarts from '~/components/SearchSavedCarts.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
export default {
    name: 'SavedCarts',
    components: {
        SavedCartsSingle,
        SearchSavedCarts,
        TranslatableStringComponent,
    },
    data() {
        return {
            isLoading: false,
            savedCartList: [],
            savedCartsCopy: [],
        }
    },
    computed: {
        ...mapState('savedCarts', ['savedCarts']),
        ...mapGetters({
            webUser: 'auth/webUser',
        }),
    },
    watch: {
        webUser: {
            async handler(newVal) {
                if (newVal) {
                    await this.fetchSavedCarts()
                }
            },
            deep: true,
        },
    },
    async mounted() {
        if (this.webUser) {
            await this.fetchSavedCarts()
        }
    },
    methods: {
        async fetchSavedCarts() {
            this.isLoading = true
            await this.$store.dispatch('savedCarts/fetchSavedCarts')
            this.savedCartList = this.savedCarts
            this.savedCartsCopy = this.savedCarts
            this.isLoading = false
        },
        searchSavedCarts(savedCartList) {
            this.isLoading = false
            this.savedCartList = savedCartList
        },
        sortSavedCartsByDate(savedCartList) {
            this.isLoading = false
            this.savedCartList = savedCartList
        },
    },
}
</script>
